//
//
//
//
//
//
//
//
//
//
//

import noData from '../../assets/img/no_data.png'

export default {
  name: 'CError',

  props: {
    errorText: {
      type: String,
      default: () => {
        return '暂无数据'
      },
    },
  },

  data () {
    return { noData }
  },
}
